import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ProfileContext from "../ProfileContext";
import useUsers from "../../../hooks/useUsers";
import { PAGE_STATE } from "../../../constants";
import AppContext from "../../../AppContext";
import SecondaryPagination from "../../SecondaryPagination/SecondaryPagination";
import useLikes from "../../../hooks/useLikes";
import useCollections from "../../../hooks/useCollections";
import useWorks from "../../../hooks/useWorks";
import _ from "lodash";
import List from "./List";
import View from "./View";

const PAGE = {
  LIST: 1,
  VIEW: 2,
};

const Collections = (props) => {
  const [selectedCollection, setSelectedCollection] = useState(undefined);
  const [page, setPage] = useState(PAGE.LIST);

  const handleViewCollection = (id) => {
    setSelectedCollection(id);
    setPage(PAGE.VIEW);
  };

  const handleReturnFromView = () => {
    setSelectedCollection(undefined);
    setPage(PAGE.LIST);
  };

  const getContent = () => {
    if (page === PAGE.LIST) {
      return <List onView={handleViewCollection} />;
    }

    if (page === PAGE.VIEW && selectedCollection) {
      return (
        <View
          collectionId={selectedCollection}
          onReturn={handleReturnFromView}
        />
      );
    }
  };

  return <div className="profile-collections">{getContent()}</div>;
};

Collections.propTypes = {};

export default Collections;
